<div class="tsd_container equipment-size-form-dialog">
  <form [formGroup]="equipmentSizeForm">
    <mat-card>
      <mat-card-content>
        <h4>{{id.value?'Edit':'Add'}} Equipment Size</h4>
        <mat-form-field class="mat-width">
          <mat-label>Equipment Size</mat-label>
          <mat-select formControlName="size" required>
            <mat-option [value]="null">None</mat-option>
            @for (size of sizes; track size) {
              <mat-option  [value]="size">
                {{size}}
              </mat-option>
            }
          </mat-select>
          @if (size.touched && size.invalid && size.hasError('required')) {
            <mat-error>Equipment Size is required</mat-error>
          }
        </mat-form-field>
        <mat-form-field class="mat-width">
          <mat-label>No of TEU</mat-label>
          <input matInput formControlName="noOfTeu" autocomplete="off" required readonly>
          @if (noOfTeu.touched && noOfTeu.invalid && noOfTeu.hasError('required')) {
            <mat-error>No of TEU is required</mat-error>
          }
        </mat-form-field>
        <mat-card-actions>
          <button mat-button color="cancel" (click)="cancel()">CANCEL</button>
          <button mat-button color="primary" (click)="save()" [disabled]="(!equipmentSizeForm.dirty)||(!editPermission && id.value) || (!addPermission && !id.value)">SAVE</button>
        </mat-card-actions>
      </mat-card-content>
    </mat-card>
  </form>
</div>
